import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import moment from 'moment';
import withTranslations from '../../translations';

import {
  Typography,
  Button,
  Chip,
  DatePicker,
  Divider,
  FormControl,
  Input,
  InputLabel,
  Radio,
  RadioGroup,
  Select,
  Switch,
} from '../base';
import Clear from '@material-ui/icons/Clear';

import {
  getMyJobs,
  getOtherJobs,
  setSorting,
  setFilters,
  clearFilters,
} from '../../actions/jobs';

import {
  filterFields,
  statusOptions,
  statusOptionsWithStarted,
} from './constants';

import {
  reportLevelOptions,
  fieldTypes,
} from '../../constants/globalFormValues';

import { timeFormat, isValidDate } from '../../constants/time';

const styles = theme => ({
  sidebar: {
    padding: theme.spacing(2),
    marginBottom: theme.spacing(8),
    overflowY: 'auto',
    minWidth: '100%',

    [theme.breakpoints.up('sm')]: {
      maxWidth: 400,
      paddingTop: theme.spacing(),
    },
  },
  header: {
    height: 48,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(2),
  },
  closeButton: {
    color: theme.palette.text.secondary,
    height: 48,
    minWidth: 48,
    borderRadius: '50%',
    padding: 0,

    '&:hover': {
      background: 'inherit',
    },
  },
  field: {
    marginBottom: theme.spacing(2),
  },
  sortingContainer: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(3),
  },
  sortingOptions: {
    flexDirection: 'row',

    '& > span': {
      padding: 0,
      margin: `0px ${theme.spacing(0.5)}px`,
    },
  },
  dateSection: {
    marginTop: theme.spacing(3),
  },
  reportLevel: {
    marginBottom: theme.spacing(3),
    marginTop: theme.spacing(2),
  },
  statusContainer: {
    display: 'inline',
  },
  datePickerContainer: {
    display: 'flex',
    justifyContent: 'space-between',

    '& > div': {
      maxWidth: '45%',
    },
  },
  statusCheckbox: {
    padding: theme.spacing(0.5),
    paddingLeft: 0,

    '&:hover': {
      background: 'transparent !important',
    },
  },
  checkBox: {
    background: theme.palette.background.default,
    border: `2px solid ${theme.palette.background.default}`
  },
  checkBoxSelected: {
    background: theme.palette.background.default,
    border: `2px solid ${theme.palette.secondary.main}`,
  },
  filterFields: {
    marginBottom: theme.spacing(2),
  },
  datepicker: {
    background: theme.palette.secondary.main,
  },
  filterButtonsContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    position: 'absolute',
    width: '100%',
    bottom: 0,
    height: 64,
  },
  clearButton: {
    color: theme.palette.error.main,
    paddingLeft: theme.spacing(2),

    '&:hover': {
      background: 'inherit',
    },
  },
  applyButton: {
    paddingRight: theme.spacing(2),

    [theme.breakpoints.up('sm')]: {
      paddingRight: theme.spacing(4),
    },

    '&:hover': {
      background: 'inherit',
    },
  },
})

class FilterJobs extends Component {
  state = {
    sort: { jobDate: this.props.sort },
    ...this.props.filter,
  };

  handleSorting = e => this.setState({ sort: { jobDate: e.target.value }});

  handleDateChange = name => date => {
    if (isValidDate(date)) {
      const properDate = name === fieldTypes.jobDateTo
        ? moment(date).set({'hour': 23, 'minute': 59, 'second': 59}).format()
        : moment(date).format();

      this.setState({
        [name]: properDate,
      });
    }
  }

  handleSelectLevel = e => this.setState({reportLevel: e.target.value});
  handleSelectSTC = e => this.setState({serviceTechnologyCenterPlannerGroup: e.target.value});
  handleSelectCC = e => this.setState({customerCenterPlantCode: e.target.value});
  handleSelectDistributor = e => this.setState({distributorCode: e.target.value});

  handleStatusChange = name => async e => {
    const value = e.target.value;

    await value
    ? this.setState(prevState => ({
        status: {...prevState.status, [name]: value}
      }))
    : this.setState(prevState => ({
        status: {...prevState.status, [name]: ''}
      }))
  }

  handleSwitchField = name => e => {
    this.setState({[name]: e.target.checked});
  }

  handleInput = name => e => {
    this.setState({[name]: e.target.value});
  }

  handleSuperSelect = name => e => {
    this.setState({
    [name]: e
  });
}

  renderApplyButton = t => (
    <Button className={this.props.classes.applyButton} onClick={this.onFilterSubmit}>
      {t.applyButton}
    </Button>
  )

  renderFilterFields = filterFields =>
    filterFields.map(({name, label, type}) => {
      const {gt} = this.props;
      switch (type) {
        case 'title':
          return <Typography variant='subtitle1' key={name} >{label}:</Typography>
        case 'switch':
          return (
            <div className={this.props.classes.field} key={name}>
              <Typography variant='subtitle1'>{label}:</Typography>
              <Switch
                disableRipple={false}
                checked={this.state[name]}
                onChange={this.handleSwitchField(name)}
              />
            </div>
          )
        case 'input':
          return (
            <FormControl fullWidth className={this.props.classes.filterFields} key={name}>
              <InputLabel>{label}</InputLabel>
              <Input value={this.state[name]} onInput={this.handleInput(name)}/>
            </FormControl>
          )
        case 'select':
          return (
            <div className={this.props.classes.field} key={name}>
              <FormControl fullWidth >
                <InputLabel htmlFor={name}>{label}</InputLabel>
                <Select
                  id={name}
                  fullWidth
                  onChange={this.handleStatusChange(name)}
                  value={this.state.status && this.state.status[name] ? this.state.status[name] : []}
                  name={name}
                  options={name === 'productInvestigation' ? statusOptionsWithStarted(gt) : statusOptions(gt)}
                  menuplacement="bottom"
                />
              </FormControl>
            </div>
          )
        default:
          return 'Invalid input field'
       }
      }
    )

  getSuperSelectOptions = type => {
    // filter centers by type
    const centers = localStorage.getItem('user') && JSON.parse(localStorage.getItem('user'))[type];

    if (centers.length) {
      return centers.reduce((acc, center) => {
        return [...acc, {value: center.code, label: center.name}]
      }, [])
    }

    return [];
  }

  onFilterSubmit = () => {
    const { sort, ...filter } = this.state;

    this.props.actions.setFilters(filter);
    this.props.actions.getMyJobs({sort, filter}, 10, 'yes');
    this.props.actions.getOtherJobs({sort, filter}, 10, 'no');
    this.props.actions.setSorting(sort.jobDate);
  }

  onClearFilters = async () => {
    await this.props.actions.clearFilters();

    this.setState({
      sort: { jobDate: this.props.sort },
      ...this.props.filter,
    })
  }

  render() {
    const
      { t, gt, classes: c, onCloseClick, } = this.props,
      { jobDateFrom, jobDateTo } = this.state;

    const STCOptions = this.getSuperSelectOptions(fieldTypes.STC);
    const CCOptions = this.getSuperSelectOptions(fieldTypes.CC);
    const distributorsOptions = this.getSuperSelectOptions(fieldTypes.distributors);

    const displayCCOptions = CCOptions.length > 0 ? CCOptions : [{ value: '', label: 'No options', disabled: true }];
    const displaySTCOptions = STCOptions.length > 0 ? STCOptions : [{ value: '', label: 'No options', disabled: true }];
    const displayDistributorsOptions = 
      distributorsOptions.length > 0 
      ? distributorsOptions
      : [{ value: '', label: 'No options', disabled: true }];


    return (
      <Fragment>
        <div className={classNames('fars-sidebar', c.sidebar)} >
          <header className={c.header}>
            <Typography variant='h6'>{t.filtersTitle}</Typography>
            <Button
              className={c.closeButton}
              onClick={onCloseClick}
            >
              <Clear />
            </Button>
          </header>
          <main>
            <section className={c.sortingContainer}>
              <Typography variant='subtitle1'>{t.sorting}:</Typography>
              <RadioGroup
                aria-label="Sort by date"
                name="sorting"
                className={c.sortingOptions}
                value={this.state.sort.jobDate}
                onChange={this.handleSorting}
              >
                <Radio
                  value='DESC'
                  disableRipple
                  icon={<Chip label={t.sortNew} className={c.checkBox} />}
                  checkedIcon={<Chip label={t.sortNew} className={c.checkBoxSelected} />}
                />
                <Radio
                  value='ASC'
                  disableRipple
                  icon={<Chip label={t.sortOld} className={c.checkBox} />}
                  checkedIcon={<Chip label={t.sortOld} className={c.checkBoxSelected} />}
                />
              </RadioGroup>
            </section>

            <Divider />
  {/* Date */}
            <section className={c.dateSection}>
              <Typography variant='subtitle1' >{t.date}:</Typography>
              <div className={c.datePickerContainer}>
                <DatePicker
                  disableFuture
                  t={gt.DatePicker}
                  placeholder={timeFormat.DATE.toLowerCase()}
                  label={t.dateFrom}
                  value={jobDateFrom}
                  maxDate={jobDateTo || moment()}
                  onChange={this.handleDateChange(fieldTypes.jobDateFrom)}
                />
                <DatePicker
                  disableFuture
                  t={gt.DatePicker}
                  placeholder={timeFormat.DATE.toLowerCase()}
                  label={t.dateTo}
                  value={jobDateTo}
                  minDate={jobDateFrom || '1900-01-01'}
                  onChange={this.handleDateChange(fieldTypes.jobDateTo)}
                />
              </div>
            </section>
  {/* end Date */}
              <FormControl fullWidth className={c.reportLevel}>
                <InputLabel htmlFor="select-level">{t.reportLevel}</InputLabel>
                <Select
                  id='select-level'
                  multiple
                  options={reportLevelOptions}
                  value={this.state.reportLevel || []}
                  onChange={this.handleSelectLevel}
                />
              </FormControl>

              {this.renderFilterFields(filterFields(t, gt.Status))}

              <FormControl fullWidth className={c.field}>
                <Typography variant='subtitle1'>{t.stcPlannerGroup}</Typography>
                <Select
                  id='stc-planner-group'
                  multiple
                  value={this.state.serviceTechnologyCenterPlannerGroup}
                  options={displaySTCOptions}
                  onChange={this.handleSelectSTC}
                />
              </FormControl>

              <FormControl fullWidth className={c.field}>
                <Typography variant='subtitle1'>{t.CCplant}</Typography>
                <Select
                  id='cc-plant'
                  multiple
                  value={this.state.customerCenterPlantCode || []}
                  options={displayCCOptions}
                  onChange={this.handleSelectCC}
                />
              </FormControl>

              <FormControl fullWidth className={c.field}>
                <Typography variant="subtitle1">{t.distributor}</Typography>
                <Select
                  id='distributor'
                  multiple
                  value={this.state.distributorCode || []}
                  options={displayDistributorsOptions}
                  onChange={this.handleSelectDistributor}
                />
              </FormControl>
          </main>
        </div>
        <footer className={c.filterButtonsContainer}>
          <Button
            className={c.clearButton}
            onClick={this.onClearFilters}
          >
            {t.clearButton}
          </Button>
          {this.renderApplyButton(t)}
        </footer>
      </Fragment>

    );
  }
}

const mapStateToProps = state => ({
  sort: state.jobs.sort.jobDate,
  filter: state.jobs.filter,
})

const mapDispatchToProps = dispatch => ({
  actions: {
    getMyJobs: bindActionCreators(getMyJobs, dispatch),
    getOtherJobs: bindActionCreators(getOtherJobs, dispatch),
    setSorting: bindActionCreators(setSorting, dispatch),
    setFilters: bindActionCreators(setFilters, dispatch),
    clearFilters: bindActionCreators(clearFilters, dispatch),
  },
})

export default withStyles(styles)(
  connect(mapStateToProps, mapDispatchToProps)(withTranslations(FilterJobs, 'Filters'))
);



// WEBPACK FOOTER //
// ./src/components/FilterJobs/FilterJobs.js